import React, { createContext, useEffect, useState } from "react";

const AppContext = createContext({});

export const AppContextProvider = ({ children }: any) => {
  const authLocal = JSON.parse(localStorage.getItem("auth") || "{}");
  const menuLocal = localStorage.getItem("menu") || "false";
  const activePageLocal = localStorage.getItem("activePage") || "";
  const viewAllLocal = localStorage.getItem("viewall") || "false";

  const [auth, setAuth] = useState(authLocal);
  const [showMenu, setShowMenu] = useState<boolean>(menuLocal === "true" ? true : false);
  const [activePage, setActivePage] = useState<string>(activePageLocal);
  const [viewAllCases, setViewAllCases] = useState<boolean>(viewAllLocal === "true" ? true : false);
  const [orgs, setOrgs] = useState<any[]>([]);

  useEffect(() => {
    localStorage.setItem("auth", JSON.stringify(auth));
  }, [auth]);

  useEffect(() => {
    localStorage.setItem("menu", showMenu ? "true" : "false");
  }, [showMenu]);

  useEffect(() => {
    localStorage.setItem("activePage", activePage);
  }, [activePage]);

  useEffect(() => {
    localStorage.setItem("viewall", viewAllCases ? "true" : "false");
  }, [viewAllCases]);

  return (
    <AppContext.Provider
      value={{ auth, setAuth, showMenu, setShowMenu, viewAllCases, setViewAllCases, activePage, setActivePage, orgs, setOrgs }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
